const actions = {
  TODO_ADD_BEGIN: 'TODO_ADD_BEGIN',
  TODO_ADD_SUCCESS: 'TODO_ADD_SUCCESS',
  TODO_ADD_ERR: 'TODO_ADD_ERR',

  TODO_DELETE_BEGIN: 'TODO_DELETE_BEGIN',
  TODO_DELETE_SUCCESS: 'TODO_DELETE_SUCCESS',
  TODO_DELETE_ERR: 'TODO_DELETE_ERR',

  TODO_READ_BEGIN: 'TODO_READ_BEGIN',
  TODO_READ_SUCCESS: 'TODO_READ_SUCCESS',
  TODO_READ_ERR: 'TODO_READ_ERR',
  
  TODO_UPDATE_BEGIN: 'TODO_UPDATE_BEGIN',
  TODO_UPDATE_SUCCESS: 'TODO_UPDATE_SUCCESS',
  TODO_UPDATE_ERR: 'TODO_UPDATE_ERR',

  todoAddBegin: () => {
    return {
      type: actions.TODO_ADD_BEGIN,
    };
  },

  todoAddSuccess: (data) => {
    return {
      type: actions.TODO_ADD_SUCCESS,
      data,
    };
  },

  todoAddErr: (err) => {
    return {
      type: actions.TODO_ADD_ERR,
      err,
    };
  },

  todoDeleteBegin: () => {
    return {
      type: actions.TODO_DELETE_BEGIN,
    };
  },

  todoDeleteSuccess: (data) => {
    return {
      type: actions.TODO_DELETE_SUCCESS,
      data,
    };
  },

  todoDeleteErr: (err) => {
    return {
      type: actions.TODO_DELETE_ERR,
      err,
    };
  },

  todoDeleteBegin: () => {
    return {
      type: actions.TODO_DELETE_BEGIN,
    };
  },

  todoDeleteSuccess: (data) => {
    return {
      type: actions.TODO_DELETE_SUCCESS,
      data,
    };
  },

  todoDeleteErr: (err) => {
    return {
      type: actions.TODO_DELETE_ERR,
      err,
    };
  },

  todoReadBegin: () => {
    return {
      type: actions.TODO_READ_BEGIN,
    };
  },

  todoReadSuccess: (data) => {
    return {
      type: actions.TODO_READ_SUCCESS,
      data,
    };
  },

  todoReadErr: (err) => {
    return {
      type: actions.TODO_READ_ERR,
      err,
    };
  },

  todoUpdateBegin: () => {
    return {
      type: actions.TODO_UPDATE_BEGIN,
    };
  },

  todoUpdateSuccess: (data) => {
    return {
      type: actions.TODO_UPDATE_SUCCESS,
      data,
    };
  },

  todoUpdateErr: (err) => {
    return {
      type: actions.TODO_UPDATE_ERR,
      err,
    };
  },
      
};

export default actions;
